// extracted by mini-css-extract-plugin
export default {"dialog":"AddServiceShareInput_dialog__Rcxdm","dialog__content":"AddServiceShareInput_dialog__content__AYkG3","dialog__footer":"AddServiceShareInput_dialog__footer__ozmug"};